import { render } from "./App.vue?vue&type=template&id=0da8a540&lang=pug"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=0da8a540&lang=scss"
import "./App.vue?vue&type=style&index=1&id=0da8a540&lang=scss"
script.render = render

export default script